import { render, staticRenderFns } from "./CrgoVoyDate.vue?vue&type=template&id=53d426dc&"
import script from "./CrgoVoyDate.vue?vue&type=script&lang=js&"
export * from "./CrgoVoyDate.vue?vue&type=script&lang=js&"
import style0 from "./CrgoVoyDate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CrgoVoyDate.vue"
export default component.exports